var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--mypage"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "mypage-title"
  }, [_c('h1', {
    staticClass: "text"
  }, [_vm._v("마이페이지")])]), _c('div', {
    staticClass: "mypage-container"
  }, [_c('mypage-navigation'), _c('div', {
    staticClass: "mypage-contents"
  }, [_c('div', {
    staticClass: "mypage-contents__body"
  }, [_c('router-view', {
    attrs: {
      "name": "question"
    }
  })], 1)])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }